module.exports = __webpack_public_path__ + "static/media/1.9b1ffda9.jpeg";